const tpl = (fields) => ({ page: 'triggers', ...fields })

export const TRIGGER_TEMPLATES_PART02 = [
  tpl({
    id: 'demo-tpl-trg-pr-review',
    title: 'Pull request review routing',
    category: 'Engineering',
    when: { app: 'GitHub', event: 'Pull request opened' },
    apps: ['GitHub', 'Slack'],
    description: 'New pull requests get a summary and the right reviewer without anyone asking around.',
    steps: [
      'Summarise what the pull request changes and why',
      'Suggest reviewers from recent owners of the touched files',
      'Post the summary to #eng-reviews',
    ],
    prompt:
      'When a pull request is opened in our GitHub repositories, summarise the change, suggest reviewers based on who last worked on the touched files, and post it to Slack #eng-reviews.',
  }),
  tpl({
    id: 'demo-tpl-trg-failed-ci',
    title: 'Failed build explainer',
    category: 'Engineering',
    when: { app: 'GitHub', event: 'Workflow run failed' },
    apps: ['GitHub', 'Slack'],
    description: 'When main goes red, the likely cause is in Slack before anyone opens the logs.',
    steps: ['Read the failing job’s logs', 'Explain the likely cause in plain English', 'Post it to #eng-alerts with the commit and author'],
    prompt:
      'When a GitHub Actions run fails on main, read the logs, explain the likely cause in plain English, and post it to Slack #eng-alerts with the commit and author.',
  }),
  tpl({
    id: 'demo-tpl-trg-contract',
    title: 'Contract review on arrival',
    category: 'Legal',
    when: { app: 'Gmail', event: 'New email with attachment' },
    apps: ['Gmail'],
    description: 'Contracts, NDAs, and order forms get a key-terms summary the moment they arrive.',
    steps: [
      'Spot attachments that look like a contract, NDA, or order form',
      'Pull out term, fees, liability cap, termination, and governing law',
      'Flag anything unusual compared with standard terms',
    ],
    prompt:
      'When an email arrives with an attachment that looks like a contract, NDA, or order form, summarise the key terms (term, fees, liability cap, termination, governing law) and flag anything unusual.',
  }),
]
